import { night1 } from './night1';
import { night2 } from './night2';
import { station } from './station';
import { night3 } from './night3';
import { night4 } from './night4';
import { night5 } from './night5';
import { night6 } from './night6';
import { night7 } from './night7';
import { night8 } from './night8';
import type { LevelDef } from './types';

/** The campaign, in order. */
export const LEVELS: LevelDef[] = [night1, night2, station, night3, night4, night5, night6, night7, night8];

export function zoneFor(level: LevelDef, c: number, r: number): 1 | 2 | 3 {
  for (const z of level.zones) {
    if (z.r0 !== undefined && r < z.r0) continue;
    if (z.r1 !== undefined && r > z.r1) continue;
    if (z.c0 !== undefined && c < z.c0) continue;
    if (z.c1 !== undefined && c > z.c1) continue;
    return z.zone;
  }
  return 1;
}
